const main = resolve => require(['@/views/index/index.vue'], resolve) // 主页
const homePage = resolve =>
  require(['@/views/homePage/index.vue'], resolve) // 首页

export default [
  {
    path: '/index',
    component: main,
    children: [
      {
        name: 'HomePage',
        path: '/aq/homePage',
        alias: ['/aq/homePage.htm'],
        component: homePage
      }
    ]
  }
]
